import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { api } from "../../api/client";
import { loginSchema, type LoginPayload } from "@heracles/shared";

export function AdminLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<LoginPayload>();

  const onSubmit = async (values: LoginPayload) => {
    setError(null);
    const parsed = loginSchema.safeParse(values);
    if (!parsed.success) {
      setError("Formulaire invalide");
      return;
    }
    try {
      await api("/admin/auth/login", { method: "POST", json: parsed.data });
      navigate("/admin/dashboard", { replace: true });
    } catch {
      setError("Identifiants invalides");
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-ink-100">
      <form onSubmit={handleSubmit(onSubmit)} className="card w-full max-w-sm">
        <h1 className="font-display text-2xl font-bold uppercase">Admin</h1>
        <label className="mt-6 block">
          <span className="mb-1 block text-sm font-semibold">Email</span>
          <input type="email" {...register("email")} className="input" required />
        </label>
        <label className="mt-4 block">
          <span className="mb-1 block text-sm font-semibold">Mot de passe</span>
          <input type="password" {...register("password")} className="input" required />
        </label>
        {error && <p className="mt-4 text-sm text-brand-500">{error}</p>}
        <button className="btn-primary mt-6 w-full" disabled={isSubmitting}>
          {isSubmitting ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
